module.exports = __webpack_public_path__ + "img/3.e62af668.jpg";